// ─────────────────────────────────────────────────────────────────
// Glass-i — Employee History feed API client (Stage HRMS-3).
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}

export const hrHistoryApi = {
  list: (params = {}) => client.get('/api/erp/hrms/employee-history', { params }).then(unwrap)
};

export default hrHistoryApi;
